var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9995 13.9791V16.3877C18.0004 16.6113 17.9545 16.8327 17.8648 17.0375C17.775 17.2424 17.6434 17.4263 17.4783 17.5775C17.3132 17.7287 17.1183 17.8437 16.906 17.9154C16.6938 17.987 16.4689 18.0136 16.2457 17.9935C13.7702 17.725 11.3923 16.8808 9.30312 15.5287C7.35937 14.296 5.71141 12.6513 4.47627 10.7114C3.11669 8.61681 2.27059 6.23208 2.00653 3.75038C1.98643 3.52835 2.01286 3.30458 2.08416 3.09332C2.15546 2.88205 2.27005 2.68791 2.42065 2.52327C2.57124 2.35862 2.75454 2.22708 2.95886 2.137C3.16319 2.04693 3.38407 2.0003 3.60744 2.00009H6.02086C6.41128 1.99626 6.78977 2.13424 7.0858 2.38831C7.38182 2.64239 7.57517 2.99522 7.62981 3.38105C7.73168 4.15187 7.92059 4.90871 8.19295 5.63715C8.30118 5.92452 8.32461 6.23683 8.26045 6.53708C8.19629 6.83733 8.04723 7.11293 7.83093 7.33123L6.80925 8.35089C7.95446 10.3609 9.62206 12.0252 11.6361 13.1682L12.6578 12.1485C12.8765 11.9327 13.1527 11.7839 13.4535 11.7199C13.7544 11.6558 14.0673 11.6792 14.3552 11.7872C15.0851 12.059 15.8435 12.2476 16.6158 12.3492C17.0066 12.4043 17.3635 12.6007 17.6186 12.9012C17.8737 13.2017 18.0093 13.5853 17.9995 13.9791Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7d89559bc553106e24debee269170520.svg";
export { ForwardRef as ReactComponent };